import { BaseTagFormValues } from "@pages/addTagsPage/addTagsPage";

export const emptyTag: BaseTagFormValues = {
    title: {},
    description: {},
    color: "",
    image: ""
};
